import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  svg {
    position: fixed;
    top: 10px;
    height: 40px;
    width: 40px;
    right: 50px;
    cursor: pointer;
  }
`;

export { Container };
